import Be, { useRef as N, useState as he, useEffect as Le, useLayoutEffect as gr } from "react";
import { Modal as ee, Form as re, InputGroup as yr, Button as Ye } from "react-bootstrap";
import { useTranslation as mr } from "react-i18next";
import _r from "react-dom";
var ge = { exports: {} }, U = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function br() {
  if (Ve)
    return U;
  Ve = 1;
  var R = Be, m = Symbol.for("react.element"), C = Symbol.for("react.fragment"), y = Object.prototype.hasOwnProperty, I = R.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function w(j, p, S) {
    var u, b = {}, d = null, P = null;
    S !== void 0 && (d = "" + S), p.key !== void 0 && (d = "" + p.key), p.ref !== void 0 && (P = p.ref);
    for (u in p)
      y.call(p, u) && !T.hasOwnProperty(u) && (b[u] = p[u]);
    if (j && j.defaultProps)
      for (u in p = j.defaultProps, p)
        b[u] === void 0 && (b[u] = p[u]);
    return { $$typeof: m, type: j, key: d, ref: P, props: b, _owner: I.current };
  }
  return U.Fragment = C, U.jsx = w, U.jsxs = w, U;
}
var B = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ue;
function Er() {
  return Ue || (Ue = 1, process.env.NODE_ENV !== "production" && function() {
    var R = Be, m = Symbol.for("react.element"), C = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), I = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), w = Symbol.for("react.provider"), j = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), S = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), P = Symbol.for("react.offscreen"), M = Symbol.iterator, W = "@@iterator";
    function A(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = M && e[M] || e[W];
      return typeof r == "function" ? r : null;
    }
    var k = R.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        ne("error", e, t);
      }
    }
    function ne(e, r, t) {
      {
        var n = k.ReactDebugCurrentFrame, i = n.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var c = t.map(function(o) {
          return String(o);
        });
        c.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, c);
      }
    }
    var L = !1, Y = !1, ae = !1, oe = !1, G = !1, J;
    J = Symbol.for("react.module.reference");
    function ie(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === y || e === T || G || e === I || e === S || e === u || oe || e === P || L || Y || ae || typeof e == "object" && e !== null && (e.$$typeof === d || e.$$typeof === b || e.$$typeof === w || e.$$typeof === j || e.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === J || e.getModuleId !== void 0));
    }
    function ye(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function s(e) {
      return e.displayName || "Context";
    }
    function l(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case y:
          return "Fragment";
        case C:
          return "Portal";
        case T:
          return "Profiler";
        case I:
          return "StrictMode";
        case S:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case j:
            var r = e;
            return s(r) + ".Consumer";
          case w:
            var t = e;
            return s(t._context) + ".Provider";
          case p:
            return ye(e, e.render, "ForwardRef");
          case b:
            var n = e.displayName || null;
            return n !== null ? n : l(e.type) || "Memo";
          case d: {
            var i = e, c = i._payload, o = i._init;
            try {
              return l(o(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var x = Object.assign, D = 0, me, _e, be, Ee, Re, Ce, xe;
    function Te() {
    }
    Te.__reactDisabledLog = !0;
    function qe() {
      {
        if (D === 0) {
          me = console.log, _e = console.info, be = console.warn, Ee = console.error, Re = console.group, Ce = console.groupCollapsed, xe = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Te,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        D++;
      }
    }
    function ze() {
      {
        if (D--, D === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: x({}, e, {
              value: me
            }),
            info: x({}, e, {
              value: _e
            }),
            warn: x({}, e, {
              value: be
            }),
            error: x({}, e, {
              value: Ee
            }),
            group: x({}, e, {
              value: Re
            }),
            groupCollapsed: x({}, e, {
              value: Ce
            }),
            groupEnd: x({}, e, {
              value: xe
            })
          });
        }
        D < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var se = k.ReactCurrentDispatcher, ce;
    function H(e, r, t) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (i) {
            var n = i.stack.trim().match(/\n( *(at )?)/);
            ce = n && n[1] || "";
          }
        return `
` + ce + e;
      }
    }
    var ue = !1, K;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      K = new Ge();
    }
    function we(e, r) {
      if (!e || ue)
        return "";
      {
        var t = K.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      ue = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = se.current, se.current = null, qe();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (O) {
              n = O;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (O) {
              n = O;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (O) {
            n = O;
          }
          e();
        }
      } catch (O) {
        if (O && n && typeof O.stack == "string") {
          for (var a = O.stack.split(`
`), _ = n.stack.split(`
`), f = a.length - 1, v = _.length - 1; f >= 1 && v >= 0 && a[f] !== _[v]; )
            v--;
          for (; f >= 1 && v >= 0; f--, v--)
            if (a[f] !== _[v]) {
              if (f !== 1 || v !== 1)
                do
                  if (f--, v--, v < 0 || a[f] !== _[v]) {
                    var E = `
` + a[f].replace(" at new ", " at ");
                    return e.displayName && E.includes("<anonymous>") && (E = E.replace("<anonymous>", e.displayName)), typeof e == "function" && K.set(e, E), E;
                  }
                while (f >= 1 && v >= 0);
              break;
            }
        }
      } finally {
        ue = !1, se.current = c, ze(), Error.prepareStackTrace = i;
      }
      var $ = e ? e.displayName || e.name : "", We = $ ? H($) : "";
      return typeof e == "function" && K.set(e, We), We;
    }
    function Je(e, r, t) {
      return we(e, !1);
    }
    function He(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function X(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return we(e, He(e));
      if (typeof e == "string")
        return H(e);
      switch (e) {
        case S:
          return H("Suspense");
        case u:
          return H("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            return Je(e.render);
          case b:
            return X(e.type, r, t);
          case d: {
            var n = e, i = n._payload, c = n._init;
            try {
              return X(c(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var Z = Object.prototype.hasOwnProperty, je = {}, Se = k.ReactDebugCurrentFrame;
    function Q(e) {
      if (e) {
        var r = e._owner, t = X(e.type, e._source, r ? r.type : null);
        Se.setExtraStackFrame(t);
      } else
        Se.setExtraStackFrame(null);
    }
    function Ke(e, r, t, n, i) {
      {
        var c = Function.call.bind(Z);
        for (var o in e)
          if (c(e, o)) {
            var a = void 0;
            try {
              if (typeof e[o] != "function") {
                var _ = Error((n || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              a = e[o](r, o, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (f) {
              a = f;
            }
            a && !(a instanceof Error) && (Q(i), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, o, typeof a), Q(null)), a instanceof Error && !(a.message in je) && (je[a.message] = !0, Q(i), g("Failed %s type: %s", t, a.message), Q(null));
          }
      }
    }
    var Xe = Array.isArray;
    function le(e) {
      return Xe(e);
    }
    function Ze(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Qe(e) {
      try {
        return Oe(e), !1;
      } catch {
        return !0;
      }
    }
    function Oe(e) {
      return "" + e;
    }
    function Pe(e) {
      if (Qe(e))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ze(e)), Oe(e);
    }
    var V = k.ReactCurrentOwner, er = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie, fe;
    fe = {};
    function rr(e) {
      if (Z.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function tr(e) {
      if (Z.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function nr(e, r) {
      if (typeof e.ref == "string" && V.current && r && V.current.stateNode !== r) {
        var t = l(V.current.type);
        fe[t] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', l(V.current.type), e.ref), fe[t] = !0);
      }
    }
    function ar(e, r) {
      {
        var t = function() {
          ke || (ke = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function or(e, r) {
      {
        var t = function() {
          Ie || (Ie = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var ir = function(e, r, t, n, i, c, o) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: m,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: c
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(a, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(a, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function sr(e, r, t, n, i) {
      {
        var c, o = {}, a = null, _ = null;
        t !== void 0 && (Pe(t), a = "" + t), tr(r) && (Pe(r.key), a = "" + r.key), rr(r) && (_ = r.ref, nr(r, i));
        for (c in r)
          Z.call(r, c) && !er.hasOwnProperty(c) && (o[c] = r[c]);
        if (e && e.defaultProps) {
          var f = e.defaultProps;
          for (c in f)
            o[c] === void 0 && (o[c] = f[c]);
        }
        if (a || _) {
          var v = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && ar(o, v), _ && or(o, v);
        }
        return ir(e, a, _, i, n, V.current, o);
      }
    }
    var de = k.ReactCurrentOwner, De = k.ReactDebugCurrentFrame;
    function F(e) {
      if (e) {
        var r = e._owner, t = X(e.type, e._source, r ? r.type : null);
        De.setExtraStackFrame(t);
      } else
        De.setExtraStackFrame(null);
    }
    var ve;
    ve = !1;
    function pe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === m;
    }
    function Ae() {
      {
        if (de.current) {
          var e = l(de.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function cr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var Fe = {};
    function ur(e) {
      {
        var r = Ae();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function $e(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ur(r);
        if (Fe[t])
          return;
        Fe[t] = !0;
        var n = "";
        e && e._owner && e._owner !== de.current && (n = " It was passed a child from " + l(e._owner.type) + "."), F(e), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), F(null);
      }
    }
    function Ne(e, r) {
      {
        if (typeof e != "object")
          return;
        if (le(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            pe(n) && $e(n, r);
          }
        else if (pe(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = A(e);
          if (typeof i == "function" && i !== e.entries)
            for (var c = i.call(e), o; !(o = c.next()).done; )
              pe(o.value) && $e(o.value, r);
        }
      }
    }
    function lr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === b))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = l(r);
          Ke(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !ve) {
          ve = !0;
          var i = l(r);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function fr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            F(e), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), F(null);
            break;
          }
        }
        e.ref !== null && (F(e), g("Invalid attribute `ref` supplied to `React.Fragment`."), F(null));
      }
    }
    function Me(e, r, t, n, i, c) {
      {
        var o = ie(e);
        if (!o) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = cr(i);
          _ ? a += _ : a += Ae();
          var f;
          e === null ? f = "null" : le(e) ? f = "array" : e !== void 0 && e.$$typeof === m ? (f = "<" + (l(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : f = typeof e, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", f, a);
        }
        var v = sr(e, r, t, i, c);
        if (v == null)
          return v;
        if (o) {
          var E = r.children;
          if (E !== void 0)
            if (n)
              if (le(E)) {
                for (var $ = 0; $ < E.length; $++)
                  Ne(E[$], e);
                Object.freeze && Object.freeze(E);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ne(E, e);
        }
        return e === y ? fr(v) : lr(v), v;
      }
    }
    function dr(e, r, t) {
      return Me(e, r, t, !0);
    }
    function vr(e, r, t) {
      return Me(e, r, t, !1);
    }
    var pr = vr, hr = dr;
    B.Fragment = y, B.jsx = pr, B.jsxs = hr;
  }()), B;
}
process.env.NODE_ENV === "production" ? ge.exports = br() : ge.exports = Er();
var h = ge.exports;
const Rr = () => /* @__PURE__ */ h.jsx("div", { children: "captcha basic" }), Cr = { plugin: { basic_captcha: {
  backend: { info: {
    name: { other: "Basic Captcha" },
    description: { other: "Default graphic verification code" }
  } },
  frontend: {
    title: "Captcha",
    placeholder: "Type the text above",
    msg: { empty: "Captcha cannot be empty." },
    verify: "Verify"
  }
} } }, xr = { plugin: { basic_captcha: {
  backend: { info: {
    name: { other: "基础验证码" },
    description: { other: "默认图形验证码" }
  } },
  frontend: {
    title: "验证码",
    placeholder: "输入上面的文本",
    msg: { empty: "验证码不能为空" },
    verify: "验证"
  }
} } }, Tr = {
  en_US: Cr,
  zh_CN: xr
};
var z = {}, q = _r;
if (process.env.NODE_ENV === "production")
  z.createRoot = q.createRoot, z.hydrateRoot = q.hydrateRoot;
else {
  var te = q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  z.createRoot = function(R, m) {
    te.usingClientEntryPoint = !0;
    try {
      return q.createRoot(R, m);
    } finally {
      te.usingClientEntryPoint = !1;
    }
  }, z.hydrateRoot = function(R, m, C) {
    te.usingClientEntryPoint = !0;
    try {
      return q.hydrateRoot(R, m, C);
    } finally {
      te.usingClientEntryPoint = !1;
    }
  };
}
const wr = ({
  captchaKey: R,
  commonProps: m
}) => new Promise((C) => {
  fetch(`/answer/api/v1/user/action/record?action=${R}`, {
    headers: {
      ...m == null ? void 0 : m.headers
    }
  }).then((y) => y.json()).then((y) => {
    console.log("checkImgCode", y), C(y.data);
  });
}), jr = ({
  captchaKey: R,
  commonProps: m
}) => {
  const C = N(null);
  C.current === null && (C.current = z.createRoot(document.createElement("div")));
  const { t: y } = mr("plugin", {
    keyPrefix: "basic_captcha.frontend"
  }), I = N(R), T = N(), w = N(!1), j = /email/i.test(I.current), [p, S] = he(!1), [u, b] = he({
    captcha_id: "",
    captcha_img: "",
    verify: !1
  }), [d, P] = he({
    value: "",
    isInvalid: !1,
    errorMsg: ""
  }), M = N(u), W = N(d), A = () => {
    w.current = !0, wr({
      captchaKey: I.current,
      commonProps: m
    }).then((s) => {
      b(s);
    }).finally(() => {
      w.current = !1;
    });
  }, k = () => {
    b({
      captcha_id: "",
      captcha_img: "",
      verify: !1
    });
  }, g = () => {
    P({
      value: "",
      isInvalid: !1,
      errorMsg: ""
    });
  }, ne = () => {
    T.current = void 0;
  }, L = () => {
    p || S(!0);
  }, Y = () => (S(!1), k(), g(), ne(), new Promise((l) => {
    setTimeout(l, 50);
  })), ae = (s = []) => {
    console.log("handleCaptchaError", s);
    const l = s.find((D) => D.error_field === "captcha_code"), x = W.current;
    return l ? (x.value && P({
      ...x,
      isInvalid: !0,
      errorMsg: l.error_msg
    }), A(), L()) : Y(), l;
  }, oe = (s) => {
    s.preventDefault(), P({
      value: s.target.value || "",
      isInvalid: !1,
      errorMsg: ""
    });
  }, G = () => {
    const s = M.current, l = W.current;
    return {
      verify: !!(s != null && s.verify),
      captcha_id: s == null ? void 0 : s.captcha_id,
      captcha_code: l.value
    };
  }, J = (s) => {
    const l = G();
    l.verify && (s.captcha_code = l.captcha_code, s.captcha_id = l.captcha_id);
  }, ie = (s) => {
    s.preventDefault(), d.value && T.current && T.current();
  };
  return Le(() => {
    j && A();
  }, []), gr(() => {
    W.current = d, M.current = u;
  }, [u, d]), Le(() => {
    var s;
    (s = C.current) == null || s.render(
      /* @__PURE__ */ h.jsxs(
        ee,
        {
          size: "sm",
          title: "Captcha",
          show: p,
          onHide: () => Y(),
          centered: !0,
          children: [
            /* @__PURE__ */ h.jsx(ee.Header, { closeButton: !0, children: /* @__PURE__ */ h.jsx(ee.Title, { as: "h5", children: y("title") }) }),
            /* @__PURE__ */ h.jsx(ee.Body, { children: /* @__PURE__ */ h.jsxs(re, { noValidate: !0, onSubmit: ie, children: [
              /* @__PURE__ */ h.jsxs(re.Group, { controlId: "code", className: "mb-3", children: [
                /* @__PURE__ */ h.jsx("div", { className: "mb-3 p-2 d-flex align-items-center justify-content-center bg-light rounded-2", children: /* @__PURE__ */ h.jsx(
                  "img",
                  {
                    src: u == null ? void 0 : u.captcha_img,
                    alt: "captcha img",
                    width: "auto",
                    height: "60px"
                  }
                ) }),
                /* @__PURE__ */ h.jsxs(yr, { children: [
                  /* @__PURE__ */ h.jsx(
                    re.Control,
                    {
                      type: "text",
                      autoComplete: "off",
                      placeholder: y("placeholder"),
                      isInvalid: d == null ? void 0 : d.isInvalid,
                      onChange: oe,
                      value: d.value
                    }
                  ),
                  /* @__PURE__ */ h.jsx(
                    Ye,
                    {
                      onClick: A,
                      variant: "outline-secondary",
                      title: y("refresh", { keyPrefix: "btns" }),
                      style: {
                        borderTopRightRadius: "0.375rem",
                        borderBottomRightRadius: "0.375rem"
                      },
                      children: /* @__PURE__ */ h.jsxs(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          fill: "currentColor",
                          className: "bi bi-arrow-repeat",
                          viewBox: "0 0 16 16",
                          children: [
                            /* @__PURE__ */ h.jsx("path", { d: "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" }),
                            /* @__PURE__ */ h.jsx(
                              "path",
                              {
                                fillRule: "evenodd",
                                d: "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
                              }
                            )
                          ]
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ h.jsx(re.Control.Feedback, { type: "invalid", children: d == null ? void 0 : d.errorMsg })
                ] })
              ] }),
              /* @__PURE__ */ h.jsx("div", { className: "d-grid", children: /* @__PURE__ */ h.jsx(Ye, { type: "submit", disabled: !d.value, children: y("verify") }) })
            ] }) })
          ]
        }
      )
    );
  }), {
    close: Y,
    show: L,
    check: (s) => w.current ? !1 : (T.current = s, u != null && u.verify ? (L(), !1) : s()),
    getCaptcha: G,
    resolveCaptchaReq: J,
    fetchCaptchaData: A,
    handleCaptchaError: ae
  };
}, Ir = {
  info: {
    type: "captcha",
    slug_name: "basic_captcha"
  },
  component: Rr,
  i18nConfig: Tr,
  hooks: {
    useCaptcha: jr
  }
};
export {
  Ir as default
};
